// @ vendors
const React = require('react');
const { formatText } = require('core/i18n').i18n;

// @ helpers
const { getSplittedNumber } = require('utilities/currencyHelper');
const { mortgagesPanelSubtitleText } = require('utilities/mortgageHelper');

// @ components
const MortgageRequestCurrencyHelp = require('components/mortgageRequest/mortgageRequestCurrencyHelp/mortgageRequestCurrencyHelp');

// @ const
const mortgageRequestType = require('constants/mortgageRequestType');

const buildPanelStepsFormated = (panelTitleFinalInfo) => {
    const importeHipoteca = panelTitleFinalInfo.get('importeHipoteca', 0) || 0;
    const cuotaMensual = panelTitleFinalInfo.get('cuotaMensual', 0) || 0;
    const paramsTotalFormatted = {
        currency: importeHipoteca,
        withDecimals: false
    };
    const paramsMonthlyFormatted = {
        currency: cuotaMensual,
        symbolCurrency: 'EUR',
        isFormated: true,
        withDecimals: true
    };
    const totalFormatted = MortgageRequestCurrencyHelp(paramsTotalFormatted);
    const monthlyFormatted = MortgageRequestCurrencyHelp(paramsMonthlyFormatted);

    return {
        totalFormatted: totalFormatted,
        monthlyFormatted: monthlyFormatted
    };
};

const buildPanelStepsConditionsText = (props) => {
    const mortgageTypeText = mortgageRequestType.getMortgageTypeText(props.panelTitleFinalInfo.get('tipoProducto'));
    const conditions = props.mortgageRequestConditionsState.get('conditions');
    const tinText = mortgagesPanelSubtitleText(conditions);
    const taeVariable = getSplittedNumber(conditions.get('taeProd', 0) * 100);
    const tae = `${taeVariable.whole}${taeVariable.decimalMark}${taeVariable.decimals}%`

    return {
        mortgageTypeText: mortgageTypeText,
        tinText: tinText,
        taeVariable: tae
    };
};

const buildPanelStepsLanguage = (data) => {
    return (
        <span>
            {`${formatText('mortgageRequestPanel-managerSectionTitleSteps')} ${data.mortgageTypeText} ${formatText('mortgageRequestPanel-managerSectionTitleStepsConector1')}
            ${data.totalFormatted} ${formatText('mortgageRequestPanel-managerSectionTitleStepsConector2')}
            ${data.panelTitleFinalInfo} ${formatText('mortgageRequestPanel-managerSectionTitleStepsConector3')} `}
            <sup>(*)</sup>
        </span>
    );
};

module.exports = {
    buildPanelStepsFormated,
    buildPanelStepsConditionsText,
    buildPanelStepsLanguage
};
